



























































































































import GroupConfig from './GroupConfig.vue';
import AppConfig from './AppConfig.vue';

export default {
	name: 'Workspaces',
	components: {
		GroupConfig,
		AppConfig,
	},
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		drawerData: {
			type: Array,
			required: true,
		},
		currentSelection: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			form: {},
			show: false,
			drawer: false,
			appDrawer: false,
			groupDrawer: false,
		};
	},
	computed: {
		organizationPath(): string {
			return this.$store.getters.path;
		},
	},
	watch: {
		visible(v) {
			this.show = v;
		},
	},
	methods: {
		onCloseRolesDrawer(): boolean {
			this.$emit('before-close');
			return true;
		},
		appName(appId: string): string {
			const app = appId === 'custom' ? { name: 'Custom' } : this.$store.state.allServices.find(el => el.id === appId);
			return app ? app.name : appId;
		},
		handleDrawerClose() {
			this.groupDrawer = false;
			this.appDrawer = false;
			this.form = {};
		},
		editRoleFromUser(data): boolean {
			return (
				(!this.currentSelection.department && !!data.role) ||
				(!this.currentSelection.department &&
					this.drawerData.find(el => el.key === data.parent) &&
					!!this.drawerData.find(el => el.key === data.parent).role)
			);
		},
		handleEditWorkspace(data) {
			if (data.type === 'app') {
				this.form.editRoleFromUser = this.editRoleFromUser(data);
				this.form.serviceId = data.serviceId;
				this.form.key = data.key;
				this.form.parent = data.parent;
				this.form.role = data.path.indexOf('roles') !== -1;
				this.form.name = data.title;
				this.form.customName = data.title;
				this.form.url = data.href;
				this.form.icon = `${data.serviceId || 'custom'}.png`;
				this.form.logo = data.logo;
				this.form.hibernate = data.hibernate;
				this.form.startHibernated = data.startHibernated;

				this.form.mobile = data.mobile;

				this.form.jsCode = data.jsCode;
				this.form.cssCode = data.cssCode;
				this.form.profile = data.profile;

				this.form.webview = {
					allowpopups: data.webview.allowpopups,
					useragent: data.webview.useragent,
				};

				this.form.proxy = {
					type: data.proxy.type,
					host: data.proxy.host,
					port: data.proxy.port,
					username: data.proxy.username,
					password: data.proxy.password,
				};
				this.form.type = data.type;
				this.form.path = data.path;
				this.appDrawer = true;
			} else {
				this.form = { ...data, editRoleFromUser: this.editRoleFromUser(data) };
				this.groupDrawer = true;
			}
		},
		newGroup(row?: any) {
			this.form = {
				editRoleFromUser: this.currentSelection.permission === 'basic',
				title: '',
				icon: 'home',
				path: row
					? `${row.path}/${row.key}/apps`
					: this.currentSelection.role &&
					  !(this.currentSelection.permission && this.currentSelection.permission === 'intermediate')
					? `${this.organizationPath}/areas/${this.currentSelection.area}/roles/${this.currentSelection.role}/workspace`
					: `${this.currentSelection.path}/${this.currentSelection.id}/workspace`,
				profile: 'inherit',
				type: 'group',
			};
			this.groupDrawer = true;
		},
		newApp(row?: any) {
			this.form = {
				editRoleFromUser: row ? this.editRoleFromUser(row) : this.currentSelection.permission === 'basic',
				type: 'app',
				jsCode: '',
				cssCode: '',
				path: row
					? `${row.path}/${row.key}/apps`
					: this.currentSelection.role &&
					  !(this.currentSelection.permission && this.currentSelection.permission === 'intermediate')
					? `${this.organizationPath}/areas/${this.currentSelection.area}/roles/${this.currentSelection.role}/workspace`
					: `${this.currentSelection.path}/${this.currentSelection.id}/workspace`,
				webview: {
					allowpopups: 'default',
					useragent: '',
				},
				proxy: {
					type: 'auto',
					host: '',
					port: 80,
					username: '',
					password: '',
				},
			};
			this.appDrawer = true;
		},
		handleDeleteWorkspace(row) {
			const h = this.$createElement;

			let msg = [
				h(
					'span',
					null,
					row.type === 'group'
						? this.$t('workspaces.deleteGroupConfirm', { name: row.title })
						: this.$t('workspaces.deleteAppConfirm', { name: row.title })
				),
			];

			this.editRoleFromUser(row) &&
				msg.unshift(
					h('el-alert', {
						attrs: {
							type: 'warning',
							title: this.$t('workspaces.affectsUsers'),
							closable: false,
							showIcon: true,
							center: true,
							style: 'margin: 10px 0 20px 0;',
						},
					})
				);

			this.$msgbox({
				title: row.type === 'group' ? this.$t('workspaces.deleteGroupTitle') : this.$t('workspaces.deleteAppTitle'),
				message: h('p', null, msg),
				showCancelButton: true,
				confirmButtonText: this.$t('common.delete'),
				cancelButtonText: this.$t('common.cancel'),
				beforeClose: async (action, instance, done) => {
					if (action !== 'confirm') return done();
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = this.$t('common.deleting');
					try {
						let data: { id: string; path: string } = { path: row.path, id: row.key };
						await this.$firebase.functions().httpsCallable(`${row.type === 'app' ? 'removeApp' : 'removeGroup'}`)(data);
						this.loading = false;
					} catch (error) {
						this.loading = false;
						console.log(error);

						this.$message({
							type: 'error',
							message: this.$translateError(error),
						});
					}
					done();
					instance.confirmButtonLoading = false;
					this.$message({
						type: 'success',
						message: this.$t('workspaces.deleteCompleted'),
					});
				},
			});
		},
	},
};
